<template>

  <Toast :group="page.name" position="bottom-center" />
  <Loader v-if="loader" />
 
  <div class="page">
    <div class="formgrid grid form-file">
      <div class="field col-12">
        <div class="button-wrapper">
          <span :class="['label', {'active': fileToUpload.length > 0}]">
            {{fileToUpload.length > 0 ? fileToUpload[0].name : 'Carica File' }}
          </span>
          <input id="upload" type="file" ref="file" @change="handleFileUpload( $event )" :accept="`${Object.values(allowedType).join(', ')}`" />
        </div>
        <div class="text-center allowed-format"> Formati consentiti: {{Object.keys(allowedType).join(', ')}} </div>
        <div v-show="validationErrors.files && submitted" class="p-error">Campo richiesto.</div>
        <div v-show="validationErrors.type && submitted" class="p-error">Formato non consentito</div>
      </div>
    </div>

    <div class="report" v-if="report && Object.keys(report.report).length">

      <template v-if="!isPreview">
        <Message v-if="report.success" severity="success">Importazione file avvenuta con successo</Message>
        <Message v-else severity="error">Importazione file annullata</Message>
      </template>
      <div class="mt-2">
        <DataTable ref="dt" :value="report.report" :filters="filters" tableStyle="width: 100%" :rowClass="rowClass">
          <template #header>
            <div class="flex justify-content-between flex-wrap">
                <div class="flex align-items-center justify-content-center mb-2">
                   <span class="p-input-icon-left">
                      <i class="pi pi-search" />
                      <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                  </span>
                </div>
                <div class="flex align-items-center justify-content-center">
                   <Button icon="pi pi-external-link" label="Esporta" @click="exportCSV($event)" class="p-button-secondary" />
                </div>
            </div>
          </template>
            <Column field="code" header="Fornitura">
              <template #body="{data}">
                <p v-if="data.fornitura_id == 0">
                {{data.code}}
                </p>
                <p v-else>
                  <router-link :to="`/ask/pods/${data.fornitura_id}/dettagli`" target="_blank">
                    {{data.code}}
                  </router-link>
                </p>
              </template>
            </Column>
            <Column field="month_from" header="Da">
              <template #body="{data}">
                {{ data.month ? data.month.split(' ')[0] : '' }}
              </template>
            </Column>
            <Column field="month_to" header="A">
              <template #body="{data}">
                {{ data.month ? data.month.split(' ')[1] : '' }}
              </template>
            </Column>
            <Column v-if="isPreview" field="importo" header="Importo">
              <template #body="{data}">
                {{data.importo}}
              </template>
            </Column>
            <Column v-if="isPreview" field="aliquota" header="Aliquota">
              <template #body="{data}">
                {{data.aliquota}}
              </template>
            </Column>
            <Column field="descrizione" header="Descrizione">
              <template #body="{data}">
                {{ data.descrizione }}
              </template>
            </Column>
            <Column field="esitoSort" header="Esito" sortable>
              <template #body="{data}">
                <template v-if="isPreview">
                  <ul v-if="data.error && data.error.length">
                    <li v-for="err in data.error" :key="err" class="p-error">
                      {{err}}
                    </li>
                  </ul>
                  <ul v-else>
                    <li>
                      <span class="text-green-500">
                        OK
                      </span>
                    </li>
                  </ul>
                </template>
                <template v-else>
                  <ul v-if="data.error && data.error.length">
                    <li v-for="err in data.error" :key="err" class="p-error">
                      {{err}}
                    </li>
                  </ul>
                  <ul v-else>
                    <li>
                      <span :class="[data.success ? 'text-green-500' : 'p-error']">
                        {{data.msg}}
                      </span>
                    </li>
                  </ul>
                </template>
              </template>
            </Column>
        </DataTable>
      

      </div>

      
    </div>
  </div>

      
  <div class="wrap-footer-main-dialog">
    <div class="footer-main-dialog">
      <div class="h-full flex align-items-center mr-3">
        <small @click="downloadTemplateFatturaVociMassivo" class="text-primary cursor-pointer">Scarica template aggiornato</small>
      </div>
      <Button 
          label="Chiudi" 
          icon="pi pi-times"
          iconPos="right" 
          class="p-button-secondary mr-3"
          @click="onCancelButton($event)" 
        />
        <Button 
          label="Preview" 
          icon="pi pi-search"
          iconPos="right" 
          class="p-button-warning mr-3"
          @click="onPreviewButton($event)" 
        />
        <Button 
          v-if="canExecute"
          label="Esegui" 
          icon="pi pi-check"
          iconPos="right" 
          class="mr-3"
          :disabled="executing"
          :loading="executing"
          @click="onOkButton($event)" 
        />
    </div>
  </div>

</template>

<script>

import { ref, getCurrentInstance} from 'vue';
// import Service from '@/services/ask-operation/operation-service'
import UtilityService from '@/services/ask-management/utility-service'
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'
import { useToast } from "primevue/usetoast";

export default {
  props: {
   data: {
      type: Object,
      required: true

    }
  },
  components: {
    Loader
  },
    
  setup(props) {
    const dt = ref();
    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
    });
    const page = { name: 'pods-aggiungi-voci-fattura-massivo'}
    const loader = ref(false)
    const toast = useToast();
    
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const formatDate = self.appContext.config.globalProperties.$formatDate
    // const service = new Service(self.$http, self.$eventBus)
    const utilityService = new UtilityService(self.$http, self.$eventBus)
    const fileToUpload = ref([])
    const allowedType = {
      'xls' : 'application/vnd.ms-excel',
      'xlsx' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    } 
    const type_fornitura = ref(props.data.type)
    const report = ref()
    const validationErrors = ref({})
    const submitted = ref(false)
    const isPreview = ref(false)
    const canExecute = ref(false)
    const executing = ref(false)
  

    const handleFileUpload = (evt) => {
      fileToUpload.value = []
      evt.preventDefault()
      submitted.value = false;
      fileToUpload.value = self.refs.file.files
      report.value = null
      isPreview.value = false
      canExecute.value = false
      executing.value = false
    }

    const rowClass = (data) => {
      if (isPreview.value && data.error && data.error.length) {
        return 'row-error-preview';
      }
      return '';
    }

    const onOkButton = () => {
      if (executing.value) {
        return
      }
      submitted.value = true;
      toast.removeGroup(page.name);
      if (validateForm() ) {
        executing.value = true
        report.value = null
        isPreview.value = false
        loader.value = true
        utilityService.addVoceInFatturaFromFile(fileToUpload.value, type_fornitura.value)
        .then((res) => {
          report.value = res.items
          if (report.value && Array.isArray(report.value.report)) {
            report.value.report = report.value.report.map(row => ({
              ...row,
              esitoSort: row.error && row.error.length ? 0 : 1
            }))
          }
          console.log(report.value);
        })
        .catch(() => {
          toast.add({severity:'error', summary: 'Attenzione', detail:'Errore nell \' analisi del file ', group: page.name});
        })
        .finally(()=>{
          fileToUpload.value = []
          loader.value = false
          executing.value = false
          self.$eventBus.emit(`dialog-return-ok-button`, {}) 
        })            

      }
    }
    
    const onCancelButton = () => {
       self.$eventBus.emit(`dialog-return-cancel-button`, {})
    }


    const onPreviewButton = () => {
      submitted.value = true;
      toast.removeGroup(page.name);
      if (validateForm()) {
        report.value = null;
        isPreview.value = true;
        loader.value = true;
        utilityService.previewFatturaVociMassivoFromFile(fileToUpload.value, type_fornitura.value)
          .then((res) => {
            report.value = res.items;
            if (report.value && Array.isArray(report.value.report)) {
              report.value.report = report.value.report.map(row => ({
                ...row,
                esitoSort: row.error && row.error.length ? 0 : 1
              }))
            }
            canExecute.value = true;
          })
          .catch(() => {
            toast.add({severity:'error', summary: 'Attenzione', detail:'Errore nella preview del file ', group: page.name});
          })
          .finally(() => {
            loader.value = false;
          });
      }
    }

    const downloadTemplateFatturaVociMassivo = () => {
      loader.value = true
      utilityService.downloadTemplateFatturaVociMassivo()
      // .then(() => {
      //   toast.add({severity:'error', summary: 'Attenzione', detail:'Errore nell \' analisi del file ', group: page.name});
      // })
      .finally(()=>{
        loader.value = false
      }) 
    }


    const validateForm = () => {

      if (fileToUpload.value.length == 0) {
          validationErrors.value['files'] = true;
          delete validationErrors.value['type'];
      } else {
        delete validationErrors.value['files'];
      }

      if (fileToUpload.value.length > 0) {
        let valid = [...fileToUpload.value].every(file => (Object.values(allowedType).join(',').replace(';',',').split(",").includes(file.type)), false);
        if (valid) 
          delete validationErrors.value['type'];
        else
          validationErrors.value['type'] = true;
      }

      return !Object.keys(validationErrors.value).length;
    }

    const exportCSV = () => {
      dt.value.exportCSV();
    };


    return {
      dt,
      filters,
      page,
      fileToUpload,
      allowedType,
      loader,
      handleFileUpload,
      downloadTemplateFatturaVociMassivo,
      report,
      validationErrors, 
      submitted,
      isPreview,
      canExecute,
      executing,
      rowClass,
      onCancelButton,
      onOkButton,
      onPreviewButton,
      formatDate,
      exportCSV
    }
  }
}


</script>

<style scoped>
.form-file .button-wrapper {
  position: relative;
  width: 100%;
  text-align: center;
}

.form-file .allowed-format {
  font-size: 12px;
  color: rgb(186, 186, 186);
  margin-top: 2px;
}

.form-file .button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #ffffff;
  border: 1px solid rgb(217, 217, 217) !important; 
  cursor: pointer;
  color: rgb(168, 168, 168);
  padding: 10px 2px;
  text-transform:uppercase;
  font-size:12px;
  border-radius: 3px;
}

.form-file .button-wrapper span.label.active {
  background: #2196F3;
  color: white;
}

.form-file #upload {
    display: inline-block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}

.row-error-preview {
  background-color: #ffe5e5 !important;
}

</style>

